import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();
  return (
    <Box sx={{ maxWidth: 720, margin: "0 auto" }}>
      <Card
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          overflow: "hidden",
          border: "1px solid #E2E8F0",
        }}
      >
        {/* Thumbnail */}
        <Box
          sx={{
            width: { xs: "100%", sm: 260 },
            minHeight: { xs: 220, sm: "auto" },
            flexShrink: 0,
            backgroundImage: `url(${process.env.PUBLIC_URL}/picdict.webp)`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundColor: "#F8FAFC",
          }}
        />

        <CardContent
          sx={{
            flex: 1,
            p: { xs: 3, md: 4 },
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          <Box>
            <Chip
              label="App"
              size="small"
              sx={{
                backgroundColor: "#EFF6FF",
                color: "#3B82F6",
                fontWeight: 600,
                fontSize: "0.7rem",
                mb: 1,
                height: 22,
              }}
            />
            <Typography
              variant="h5"
              component="div"
              sx={{ fontWeight: 700, color: "#0F172A", fontSize: "1.15rem" }}
            >
              {t("home.portfolio.title")}
            </Typography>
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ lineHeight: 1.8, fontSize: "0.88rem" }}
          >
            {t("home.portfolio.description")}
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ lineHeight: 1.8, fontSize: "0.88rem" }}
          >
            {t("home.portfolio.detail")}
          </Typography>

          <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
            <Button
              component="a"
              href="https://picdict.net"
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              size="small"
              endIcon={<OpenInNewIcon />}
              sx={{
                backgroundColor: "#3B82F6",
                "&:hover": { backgroundColor: "#2563EB" },
                textTransform: "none",
                fontSize: "0.8rem",
              }}
            >
              Visit Site
            </Button>
            <Button
              component={Link}
              to="/biography#picdict"
              variant="outlined"
              size="small"
              sx={{
                borderColor: "#CBD5E1",
                color: "#64748B",
                "&:hover": { borderColor: "#94A3B8" },
                textTransform: "none",
                fontSize: "0.8rem",
              }}
            >
              Bio
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
